<template>
  <div class="d-flex w-100">
  <v-autocomplete :id="label?'autocomplete_'+$helper.slugify(label):''" ref="autocomplete" :loading="loading" @change="changed" :dense="dense" outlined :rules="rules"
    :label="label" :value="value && value.isVariable?value.id:value" :placeholder="placeholder" :search-input.sync="search" :items="filterItems"
    :item-text="getTitle" item-value="id" auto-select-first no-filter :return-object="returnObject" :readonly="readonly"
    :required="required" :disabled="disabled" :hide-details="hideDetails" :clearable="clearable" :style="info?'border-top-right-radius: 0;border-bottom-right-radius: 0;':''">
    <template v-slot:prepend-item>
      <v-subheader>Zoekresultaten</v-subheader>
      <v-list-item v-if="!search || search == ''">
        <v-list-item-content>
          <v-list-item-title v-html="searchText"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:item="{ item }">
      <slot name="item" :item="item">
      <v-list-item-content>
        <v-list-item-title v-text="getTitle(item)"></v-list-item-title>
        <v-list-item-subtitle v-text="getDescription(item)"></v-list-item-subtitle>
      </v-list-item-content>
      </slot>
    </template>
    <template v-slot:no-data>
      <v-list-item v-if="search && search != ''">
        <v-list-item-content>
          <v-list-item-title v-html="noDataText"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-else style="display:none;">
      </v-list-item>
    </template>
    <template v-slot:append-item>
      <template v-if="variables && variables.length > 0">
        <v-subheader>Variabele</v-subheader>
        <v-list-item v-for="variable in variables" :key="variable.value"
          @click="variableClicked(variable)">
          <v-list-item-content>
            <v-list-item-title>{{ variable.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-if="visibleSuggestions.length > 0 && (!search || search == '')">
        <v-subheader>Voorstel</v-subheader>
        <v-list-item v-for="suggestion in visibleSuggestions" :key="suggestion.id"
          @click="suggestionClicked(suggestion)">
          <slot name="item" :item="suggestion">
          <v-list-item-content>
            <v-list-item-title>{{ getTitle(suggestion) }}</v-list-item-title>
            <v-list-item-subtitle v-text="getDescription(suggestion)"></v-list-item-subtitle>
          </v-list-item-content>
          </slot>
        </v-list-item>
      </template>
      <slot name="append-item"></slot>
    </template>
  </v-autocomplete>
  <div v-if="info" class="grey lighten-3 d-flex align-center" style="border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
                <v-tooltip top open-on-click :open-on-focus="false">
                    <template v-slot:activator="{on, attrs}">
                        <v-btn v-bind="attrs" v-on="on" icon small><v-icon small>mdi-information-variant</v-icon></v-btn>
                    </template>
                    <div style="max-width:240px;" v-html="info"></div>
                </v-tooltip>
            </div>
  </div>
</template>
<script>
import User from './../models/user';
import _ from 'lodash';

export default {
  props: {
    label: String,
    noDataText: {
      type: String,
      default: 'Geen items gevonden met uw zoekopdracht'
    },
    searchText: {
      type: String,
      default: 'Zoek voor meer resultaten...'
    },
    value: Object | String,
    endpoint: String,
    placeholder: String,
    itemText: String,
    extraItems: {
      type: Object,
      default: () => { return {} }
    },
    exclude: {
      type: Array,
      default: () => {
        return [];
      }
    },
    fields: {
      type: Array,
      default: () => {
        return ['id', 'name', 'description'];
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noAutoselect: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    suggestions: {
      type: Array,
      default: () => ([])
    },
    variables: {
      type: Array,
      default: () => ([])
    },
    defaultFilter: {
      type: Object,
      default: () => ({})
    },
    info: String,
  },
  data: () => ({
    noData: false,
    search: '',
    items: [],
    timeout: null,
    loading: false,
    resolvedSuggestions: []
  }),
  mounted() {
    this.init(true);

    if (this.suggestions.length > 0) {
      this.$eod.get(this.endpoint, this.fields, {
        whereIn: {
          column: 'id',
          array: this.suggestions
        }
      }).then(response => {
        if (response.data.data) {
          this.resolvedSuggestions = response.data.data[this.endpoint].edges;
        }

      })
    }
  },
  computed: {
    filterItems() {
      let filterItems = [];
      if (this.items) {
        filterItems = this.items;
      }

      if (this.extraItems.start) {
        for (let i = this.extraItems.start.length - 1; i >= 0; i--) {
          const item = this.extraItems.start[i];
          filterItems.unshift(item);
        }
      }

      if (this.extraItems.end) {
        for (let i = 0; i < this.extraItems.end.length; i++) {
          const item = this.extraItems.end[i];
          filterItems.push(item);
        }
      }

      return filterItems;
    },
    visibleSuggestions() {
      // Items die al onder 'Zoekresultaten' staan niet nog een tweede keer als voorstel tonen.
      const shownIds = this.filterItems.map(item => item.id);
      return this.resolvedSuggestions.filter(suggestion => !shownIds.includes(suggestion.id));
    }
  },
  watch: {
    endpoint(val) {
      this.items = [];
    },
    search(val) {
      this.searchItems(val);
    },
    value(val, oldVal) {
      if (oldVal) {
        if (typeof val == 'string' && val == oldVal) {
          return false;
        } else if (val && val.id && oldVal && oldVal.id && val.id == oldVal.id) {
          return false;
        }
      }

      this.init();
    }
  },
  methods: {
    init(initial) {
      if(this.value){
        if(this.returnObject){
          if(this.filterItems.filter(item => item.id == this.value.id).length > 0){
            return;
          }
        } else {
          if(this.filterItems.filter(item => item.id == this.value).length > 0){
            return;
          }
        }
      }

      this.loading = true;

        let variables = {
          limit: 5
        };
        variables = _.mergeWith(variables, this.defaultFilter, this.customMerge);

        this.$eod.get(this.endpoint, this.fields, variables).then(result => {
          if (result.data.data) {
            // Enkel terugvallen op de eerste resultaten van het endpoint wanneer er geen
            // expliciete suggestions meegegeven zijn - die worden in mounted() opgehaald
            // en mogen hier niet overschreven worden.
            if (this.suggestions.length == 0) {
              this.resolvedSuggestions = this.excludeItems(result.data.data[this.endpoint].edges);
            }
            if(!this.value && result.data.data[this.endpoint].edges.length == 1 && !this.noAutoselect){
              const item = result.data.data[this.endpoint].edges[0];
              this.items = [item];
              this.selectInAutocomplete(item);
            }
          }
        }).then(() => {
          if (this.value){
              let ids = [];
              if (typeof this.value == 'string') {
                ids.push(this.value);
              } else if (Array.isArray(this.value)) {
                for (let i = 0; i < this.value.length; i++) {
                  const item = this.value[i];
                  ids.push(item.id);
                }
              } else if (this.value.isVariable && this.variables) {
                for (let i = 0; i < this.variables.length; i++) {
                  const variable = this.variables[i];
                  if(variable.value == this.value.id){
                    this.variableClicked(variable);
                    
                    break;
                  }
                }
                return false;
              } else if (this.value.id && this.value.name) {
                this.items = [this.value];
                return false;
              } else if (this.value.id) {
                ids.push(this.value.id);
              } else {
                return false;
              }

              this.loading = true;
              return this.$eod.get(this.endpoint, this.fields, {
                whereIn: {
                  column: 'id',
                  array: ids
                }
              }).then(result => {
                let results = result.data.data[this.endpoint].edges;
                this.items = results;

                if (initial && this.value) {
                  for (let i = 0; i < this.items.length; i++) {
                    const item = this.items[i];
                    if (typeof this.value == 'string' && item.id == this.value) {
                      if (this.returnObject) {
                        this.changed(item);
                      } else {
                        this.changed(item.id);
                      }
                    } else if (this.value.id && item.id == this.value.id) {
                      if (this.returnObject) {
                        this.changed(item);
                      } else {
                        this.changed(item.id);
                      }
                    }
                  }
                }
              }).finally(() => {
                this.loading = false;
              });
            }
          }
        ).finally(() => {
          this.loading = false;
        });
    },
    variableClicked(variable){

      const item = {
        isVariable: true,
        id: variable.value,
        name: 'VAR: ' + variable.text
      };

      this.items = [item];
      // Een variabele wordt altijd als object doorgegeven: de parent herkent ze aan isVariable.
      this.selectInAutocomplete(item, item);
    },
    suggestionClicked(suggestion) {
      this.items = [suggestion];
      this.selectInAutocomplete(suggestion);
    },
    /**
     * Laat de onderliggende v-autocomplete de selectie zelf registreren, net zoals bij een klik
     * op een zoekresultaat. Zonder dat hangt het gevulde veld volledig af van de parent die de
     * waarde via de value-prop terugstuurt - en dat gebeurt niet wanneer die de sleutel nog niet
     * reactief had staan (eodportal#1503). Emit als fallback wanneer de ref er nog niet is.
     */
    selectInAutocomplete(item, forcedValue) {
      const value = forcedValue !== undefined ? forcedValue : (this.returnObject ? item : item.id);

      this.$nextTick(() => {
        const autocomplete = this.$refs.autocomplete;

        if (autocomplete && forcedValue === undefined && typeof autocomplete.selectItem == 'function') {
          autocomplete.selectItem(item);
          return;
        }

        if (autocomplete && typeof autocomplete.setValue == 'function') {
          autocomplete.setValue(value);
          autocomplete.isMenuActive = false;
          return;
        }

        this.changed(value);

        if (autocomplete) {
          autocomplete.isMenuActive = false;
        }
      });
    },
    getTitle(item) {
      if (item.name) {
        return item.name;
      } else if (item.firstName || item.username) {
        let usr = new User(item);
        return usr.getFullName();
      }

      return '';
    },
    getDescription(item) {
      if(this.endpoint == 'measurementTypes'){
        return (item.unit && item.unit.name?item.unit.name:'')
      } else if (item.description) {
        return item.description;
      } else if (item.firstName || item.username) {
        let usr = new User(item);
        if(usr.getRole()){
          return this.$t(usr.getRole().name);
        }
      }

      return null;
    },
    changed(e) {
      this.$emit('input', e);
      this.$emit('change', e);
    },
    excludeItems(results) {

      let my_ids = [];

      if (this.value) {
        if (typeof this.value == 'string') {
          my_ids.push(this.value);
        } else {
          for (let i = 0; i < this.value.length; i++) {
            const item = this.value[i];
            my_ids.push(item.id);
          }
        }
      }

      if (this.exclude.length > 0) {
        let exclude_ids = [];
        for (let i = 0; i < this.exclude.length; i++) {
          exclude_ids.push(this.exclude[i].id);
        }

        for (let i = 0; i < results.length; i++) {
          if (exclude_ids.includes(results[i].id) && !my_ids.includes(results[i].id)) {
            results.splice(i, 1);
          }
        }
      }

      return results;
    },
    customMerge(objValue, srcValue) {
      if (_.isArray(objValue)) {
        return objValue.concat(srcValue);
      }
    },
    searchItems(search) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      if (search == null) {
        this.noData = false;
        return false;
      }

      if (search == '') {
        this.noData = false;
        this.items = [];
        return false;
      }

      if(this.value){
        if(this.returnObject){
          if(this.filterItems.filter(item => item.id == this.value.id).length > 0){
            return;
          }
        } else {
          if(this.filterItems.filter(item => item.id == this.value).length > 0){
            return;
          }
        }
      }

      if(this.value && this.value.isVariable && search == this.value.name){
        for (let i = 0; i < this.variables.length; i++) {
            const variable = this.variables[i];
            if(variable.value == this.value.id){
              this.items=[{
                id: variable.value,
                name: variable.text
              }];
              break;
            }
          }
        this.items=[this.value];
        return false;
      }

      if(this.returnObject && this.value && this.value.name){
        if(this.value.name == search){
          this.items = [this.value];
          return false;
        }
      }

      this.timeout = setTimeout(() => {

        let variables = {};
        let fields = this.fields;

        variables.search = search;

        if (this.endpoint == 'users' || this.endpoint == 'resolveUsers') {
          fields = ['id', 'firstName', 'lastName', 'username', 'assignedRealmRoles{id name}'];
        }

        variables = _.mergeWith(variables, this.defaultFilter, this.customMerge);

        this.loading = true;
        this.$eod.get(this.endpoint, fields, variables)
          .then(result => {
            this.items = [];
            let results = result.data.data[this.endpoint].edges;
            results = this.excludeItems(results);

            let count = results.length;

            if (count == 0) {
              this.noData = true;
            } else {
              this.noData = false;
              this.items = results;
            }

            this.timeout = null;

            this.$forceUpdate();

          }).finally(() => {
            this.loading = false;
          });
      }, 500);

    },
  }
}
</script>